import * as z from "zod";
import { carrierClaimsFilterSchema } from "./carrier-claims-analytics-common";

export const carrierClaimsDenialRowSchema = z.object({
  carrierKey: z.string(),
  carrierLabel: z.string(),
  reasonKey: z.string(),
  reasonLabel: z.string(),
  count: z.number(),
});
export type CarrierClaimsDenialRow = z.infer<
  typeof carrierClaimsDenialRowSchema
>;

export const getCarrierClaimsDenialReasons = {
  name: "getCarrierClaimsDenialReasons" as const,
  input: carrierClaimsFilterSchema,
  output: z.object({ rows: z.array(carrierClaimsDenialRowSchema) }),
};

export type GetCarrierClaimsDenialReasonsOutput = z.infer<
  typeof getCarrierClaimsDenialReasons.output
>;
